<div class="wizard">
  <!-- Top bar: back + progress + voice toggle, always visible -->
  <div class="topbar">
    <div class="topbar-start">
      <button mat-icon-button class="voltar-btn" *ngIf="podeVoltar" (click)="voltar()"
              aria-label="Voltar">
        <mat-icon>arrow_back</mat-icon>
      </button>
      <div class="dots" aria-label="progresso" *ngIf="mostrarDots">
        <span *ngFor="let on of dots" class="dot" [class.on]="on"></span>
      </div>
    </div>
    <button mat-icon-button class="voz-btn" (click)="alternarVoz()"
            [attr.aria-label]="voz ? 'Desligar voz' : 'Ligar voz'">
      <mat-icon>{{ voz ? 'volume_up' : 'volume_off' }}</mat-icon>
    </button>
  </div>

  <!-- Guidance heading, shown on every screen (hidden on the embedded result) -->
  <header class="guia" *ngIf="!(embedded && step === 'resultado')">
    <h1>{{ guia.titulo }}</h1>
    <p *ngIf="guia.corpo">{{ guia.corpo }}</p>
  </header>

  <ng-container [ngSwitch]="step">
    <!-- ============ WELCOME ============ -->
    <ng-container *ngSwitchCase="'inicio'">
      <div class="centro">
        <mat-icon class="hero-icon">photo_camera</mat-icon>
        <button mat-flat-button class="botao-grande verde" (click)="comecar()">
          <mat-icon>play_arrow</mat-icon> Começar
        </button>
      </div>
    </ng-container>

    <!-- ============ CHOOSE METHOD ============ -->
    <ng-container *ngSwitchCase="'escolha'">
      <div class="centro">
        <button mat-flat-button class="botao-grande verde" (click)="escolher('camera')">
          <mat-icon>photo_camera</mat-icon> Tirar foto agora
        </button>
        <button mat-stroked-button class="botao-grande" (click)="escolher('upload')">
          <mat-icon>upload_file</mat-icon> Enviar do meu aparelho
        </button>
      </div>
    </ng-container>

    <!-- ============ CAPTURE / UPLOAD FRONT ============ -->
    <ng-container *ngSwitchCase="'frente'">
      <app-doc-illustration *ngIf="metodo === 'camera'" kind="frente"></app-doc-illustration>
      <div class="camera-wrap" [class.upload]="metodo === 'upload'">
        <brdocs-capture
          [kiosk]="true"
          [source]="metodo"
          [digitalFirst]="metodo === 'upload'"
          [manualFallbackMs]="manualFallbackMs"
          (documentConfirmed)="onFrenteConfirmed($event)"
          (digitalRecognized)="onDigital($event)"
          (switchToUpload)="aoTrocarParaUpload()"
          (debug)="forwardDebug($event)"></brdocs-capture>
        <div *ngIf="metodo === 'camera'" class="moldura"></div>
      </div>
      <!-- Camera: the one auto-capture fact (upload needs no hint — the body already
           says which files are accepted). -->
      <p *ngIf="metodo === 'camera'" class="dica"><mat-icon>info</mat-icon> A foto é tirada sozinha quando ficar nítida.</p>
    </ng-container>

    <!-- ============ REVIEW FRONT ============ -->
    <ng-container *ngSwitchCase="'confere-frente'">
      <div class="preview">
        <img [src]="frente!.rawDataUrl" alt="Frente do documento" />
        <p *ngIf="frente!.recognized && !frentePareceVerso" class="tipo"><mat-icon>{{ meta?.icon ?? 'badge' }}</mat-icon> {{ nomeDoc }}</p>
      </div>

      <!-- Wrong-side hint: the classifier says this is the BACK, not the front. -->
      <div *ngIf="frentePareceVerso" class="aviso" data-testid="brdocs-wrong-side-hint">
        <mat-icon>flip_camera_android</mat-icon> {{ 'BrdocsWrongSideHint' | translate }}
      </div>

      <div class="acoes" *ngIf="frentePareceVerso; else acoesFrenteOk">
        <button mat-flat-button class="botao-grande verde" (click)="refazerFrente()"
                data-testid="brdocs-wrong-side-retake">
          <mat-icon>{{ rotuloRefazer.icon }}</mat-icon> {{ 'BrdocsWrongSideRetake' | translate }}
        </button>
        <button mat-stroked-button class="botao-grande" (click)="manterComoFrente()"
                data-testid="brdocs-wrong-side-keep">
          <mat-icon>arrow_forward</mat-icon> {{ 'BrdocsWrongSideKeep' | translate }}
        </button>
      </div>
      <ng-template #acoesFrenteOk>
        <div class="acoes">
          <button mat-flat-button class="botao-grande verde" (click)="aceitarFrente()"
                  data-testid="brdocs-front-accept">
            <mat-icon>check</mat-icon> Sim, está boa
          </button>
          <button mat-stroked-button class="botao-grande" (click)="refazerFrente()"
                  data-testid="brdocs-front-retake">
            <mat-icon>{{ rotuloRefazer.icon }}</mat-icon> {{ rotuloRefazer.texto }}
          </button>
        </div>
      </ng-template>
    </ng-container>

    <!-- ============ MANUAL DOCUMENT-TYPE PICKER (detection failed) ============ -->
    <ng-container *ngSwitchCase="'tipo-doc'">
      <div class="acoes tipos" data-testid="brdocs-type-picker" *ngIf="!confirmandoOutro">
        <button mat-stroked-button class="botao-grande" *ngFor="let t of tiposManuais"
                (click)="escolherTipo(t.familia)"
                [attr.data-testid]="'brdocs-type-' + t.familia">
          <mat-icon>{{ t.icon }}</mat-icon> {{ t.nome }}
        </button>
        <button mat-stroked-button class="botao-grande" (click)="pedirConfirmacaoOutro()"
                data-testid="brdocs-type-other">
          <mat-icon>help_outline</mat-icon> {{ 'BrdocsManualTypeOther' | translate }}
        </button>
      </div>

      <!-- "Other / not listed" disclaimer: we may need to ask for another ID.
           The disclaimer text itself is shown in the header (guia.corpo). -->
      <div class="acoes" *ngIf="confirmandoOutro" data-testid="brdocs-type-other-disclaimer">
        <button mat-flat-button class="botao-grande verde" (click)="escolherTipo(outroFamilia)"
                data-testid="brdocs-type-other-proceed">
          <mat-icon>arrow_forward</mat-icon> {{ 'BrdocsManualTypeOtherProceed' | translate }}
        </button>
        <button mat-stroked-button class="botao-grande" (click)="cancelarOutro()"
                data-testid="brdocs-type-other-back">
          <mat-icon>arrow_back</mat-icon> {{ 'BrdocsManualTypeOtherBack' | translate }}
        </button>
      </div>
    </ng-container>

    <!-- ============ CAPTURE / UPLOAD BACK (the OUTER back — never the QR page) ============
         This is the image Veriff verifies as `document-back`. For a folded document
         (CNH) that is the closed document's categories side; its QR page is a separate
         surface captured at `interna-foto`. The "scan the QR with the camera" escape
         that used to live here skipped this step entirely and let the QR still stand in
         as the back — Veriff declined every one of those with 609 "Document back
         missing". It now lives on the inner-page step, downstream of this photo. -->
    <ng-container *ngSwitchCase="'verso-foto'">
      <app-doc-illustration [kind]="$any(ilustracaoVerso)"></app-doc-illustration>
      <div class="camera-wrap" [class.upload]="metodo === 'upload'">
        <brdocs-capture
          [kiosk]="true"
          [source]="metodo"
          [manualFallbackMs]="manualFallbackMs"
          (documentConfirmed)="onVersoConfirmed($event)"
          (switchToUpload)="aoTrocarParaUpload()"
          (debug)="forwardDebug($event)"></brdocs-capture>
        <div *ngIf="metodo === 'camera'" class="moldura"></div>
      </div>
      <!-- Camera: same auto-capture hint as the front. -->
      <p *ngIf="metodo === 'camera'" class="dica"><mat-icon>info</mat-icon> A foto é tirada sozinha quando ficar nítida.</p>
      <!-- Upload + a doc whose QR is on THIS surface (CIN): the only extra fact is that
           the QR must be fully visible. A CNH is excluded (its QR is on the inner page)
           and the plain upload case needs no hint — the body already says what to pick. -->
      <p *ngIf="metodo === 'upload' && versoComQrUpload" class="dica dica-qr" data-testid="brdocs-upload-back-qr-hint">
        <mat-icon>qr_code_2</mat-icon> {{ 'BrdocsUploadBackQrGuidance' | translate }}
      </p>
    </ng-container>

    <!-- ============ CAPTURE / UPLOAD THE INNER (QR) PAGE OF A FOLDED DOC ============
         Third surface, reached only once the outer back is banked. Read for its signed
         QR and MRZ; deliberately NOT part of CaptureFlowResult, so it can never be
         submitted as the document back. -->
    <ng-container *ngSwitchCase="'interna-foto'">
      <app-doc-illustration [kind]="$any('cnh-interna')"></app-doc-illustration>
      <div class="camera-wrap" [class.upload]="metodo === 'upload'">
        <brdocs-capture
          [kiosk]="true"
          [source]="metodo"
          [manualFallbackMs]="manualFallbackMs"
          (documentConfirmed)="onInternaConfirmed($event)"
          (switchToUpload)="aoTrocarParaUpload()"
          (debug)="forwardDebug($event)"></brdocs-capture>
        <div *ngIf="metodo === 'camera'" class="moldura"></div>
      </div>
      <p class="dica dica-qr" data-testid="brdocs-inner-qr-hint">
        <mat-icon>qr_code_2</mat-icon> {{ 'BrdocsInnerPageQrGuidance' | translate }}
      </p>
      <!-- Reading a QR out of a still fails on glare/crop/blur; offer the focused,
           retryable live scan of this same page. -->
      <button *ngIf="metodo === 'upload'" mat-stroked-button class="botao-grande"
              (click)="escanearQrComCamera()" data-testid="brdocs-scan-qr-camera">
        <mat-icon>photo_camera</mat-icon> {{ 'BrdocsScanQrWithCameraInstead' | translate }}
      </button>
    </ng-container>

    <!-- ============ REVIEW BACK ============ -->
    <ng-container *ngSwitchCase="'confere-verso'">
      <div class="preview">
        <img [src]="verso!.rawDataUrl" alt="Verso do documento" />
      </div>
      <div class="acoes">
        <button mat-flat-button class="botao-grande verde" (click)="aceitarVerso()">
          <mat-icon>check</mat-icon> Sim, está boa
        </button>
        <button mat-stroked-button class="botao-grande" (click)="refazerVerso()">
          <mat-icon>{{ rotuloRefazer.icon }}</mat-icon> {{ rotuloRefazer.texto }}
        </button>
      </div>
    </ng-container>

    <!-- ============ LIVE QR SCAN (focused, full-res) ============ -->
    <ng-container *ngSwitchCase="'qr'">
      <app-doc-illustration [kind]="$any(ilustracaoQr)"></app-doc-illustration>
      <app-qr-capture
        (decoded)="onQr($event)"
        (cameraError)="onQrErro()"
        (debug)="forwardDebug($event)"></app-qr-capture>
      <p class="dica"><mat-icon>qr_code_2</mat-icon> Encaixe o código QR dentro do quadrado verde.</p>
      <!-- Withheld for the first seconds on screen (see ATRASO_PULAR_MS): the signed QR
           is the only authoritative source of the CPF, so the user gets a real chance to
           scan before being offered a way out. -->
      <button *ngIf="podePular" mat-stroked-button class="botao-grande botao-pular"
              (click)="pularQr()" data-testid="brdocs-skip-qr">
        <mat-icon>skip_next</mat-icon> Não consigo ler o QR agora
      </button>
    </ng-container>

    <!-- ============ DIGITAL PDF REJECTED (screenshot / unsigned) ============ -->
    <ng-container *ngSwitchCase="'pdf-erro'">
      <div class="centro">
        <mat-icon class="hero-icon erro">gpp_bad</mat-icon>
        <button mat-flat-button class="botao-grande verde" (click)="recomecar()"
                data-testid="brdocs-pdf-erro-restart">
          <mat-icon>restart_alt</mat-icon> {{ 'BrdocsPdfErroRetry' | translate }}
        </button>
      </div>
    </ng-container>

    <!-- ============ NOT A DOCUMENT (CPK-5103) ============
         The is_document check found no document in the image just sent. Shown instead of the
         "ficou boa?" preview: the image, what to send instead, and one way back to capturing
         that same side. Deliberately different from the "could not read CPF/DOB/name" message
         (right document, unclear photo) — this one means "wrong thing". -->
    <ng-container *ngSwitchCase="'nao-documento'">
      <div class="preview" *ngIf="naoDocumentoImg as img">
        <img [src]="img" [alt]="'BrdocsNotDocumentImageAlt' | translate" />
      </div>
      <p class="nao-documento-texto" data-testid="brdocs-not-document-body">
        {{ (metodo === 'upload' ? 'BrdocsNotDocumentBodyUpload' : 'BrdocsNotDocumentBodyCamera') | translate }}
      </p>
      <div class="acoes">
        <button mat-stroked-button class="botao-grande" (click)="tentarDeNovoNaoDocumento()"
                data-testid="brdocs-not-document-retry">
          <mat-icon>{{ rotuloRefazer.icon }}</mat-icon>
          {{ (metodo === 'upload' ? 'BrdocsNotDocumentRetryUpload' : 'BrdocsNotDocumentRetryCamera') | translate }}
        </button>
      </div>
    </ng-container>

    <!-- ============ PROCESSING ============ -->
    <ng-container *ngSwitchCase="'processando'">
      <div class="centro">
        <mat-spinner diameter="72"></mat-spinner>
      </div>
    </ng-container>

    <!-- ============ RESULT ============ -->
    <ng-container *ngSwitchCase="'resultado'">
      <!-- Embedded: the host (e.g. the KYC confirmation) takes over — show no data dump. -->
      <div class="centro" *ngIf="embedded">
        <mat-spinner diameter="72"></mat-spinner>
      </div>

      <div class="resultado" *ngIf="!embedded">
        <div class="cabecalho-ok">
          <mat-icon class="check-grande">check_circle</mat-icon>
          <span class="tipo-doc">
            <mat-icon>{{ meta?.icon ?? 'badge' }}</mat-icon> {{ nomeDoc }}
          </span>
        </div>

        <img *ngIf="fotoPessoa as foto" class="foto-pessoa" [src]="foto" alt="Foto do titular" />

        <div *ngIf="assinatura as s" class="assinatura" [class]="statusAssinatura(s).cls">
          <mat-icon>{{ statusAssinatura(s).icon }}</mat-icon>
          {{ statusAssinatura(s).texto }}
        </div>

        <div *ngIf="aviso as a" class="aviso"><mat-icon>warning</mat-icon> {{ a }}</div>

        <ng-container *ngIf="campos.length; else semCampos">
          <div class="campos">
            <div *ngFor="let c of campos; trackBy: trackByLabel" class="campo" [class.ocr]="c.fonte === 'ocr'">
              <span class="rotulo">{{ c.label }}</span>
              <span class="valor">{{ c.value }}</span>
              <mat-icon *ngIf="c.fonte === 'qr'" class="selo" title="Lido do código do documento">verified</mat-icon>
            </div>
          </div>
          <p class="legenda">
            <mat-icon class="selo">verified</mat-icon> = lido do código oficial do documento.
            Os demais foram lidos do texto e podem conter erros.
          </p>
        </ng-container>
        <ng-template #semCampos>
          <p class="nada">Não consegui extrair informações deste documento.</p>
        </ng-template>

        <!-- The captured sides, for reference -->
        <div class="lados">
          <figure *ngIf="frente as f"><figcaption>Frente</figcaption><img [src]="f.rawDataUrl" alt="Frente" /></figure>
          <figure *ngIf="versoImg as v"><figcaption>Verso</figcaption><img [src]="v" alt="Verso" /></figure>
        </div>

        <button mat-flat-button class="botao-grande" (click)="recomecar()">
          <mat-icon>restart_alt</mat-icon> Ler outro documento
        </button>
      </div>
    </ng-container>
  </ng-container>
</div>
